import React, { useState} from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./Slider.css";
import './TestimonialSlider.css'; // Create a CSS file for styling
import is1 from '../Images/is1.png';
import is2 from '../Images/is2.png';
import is3 from '../Images/is3.png';
import is4 from '../Images/is4.png';
import is5 from '../Images/is5.png';
import is6 from '../Images/is6.png';


  const items = [
    {
      image:is1,
      paragraph:"AIML Data are the experts in crowd management and have a world class assurance team. We can focus our energy more on our models and less on the quality of annotations.",
      line:"--LARGE SAAS DATA PROVIDER",
    },
    {
      image:is2,
      paragraph:"Working with AIML data has been a great experience. They quickly learnt our line of business, adapted to our requirements and have consistedly performed well. They are reliable and wonderful partner.",
      line:"--LEADING BIOPHARMACEUTICAL COMPANY",
    },
    {
      image:is3,
      paragraph:"AIML Data are the experts in crowd management and have a world class assurance team. We can focus our energy more on our models and less on the quality of annotations.",
      line:"--LARGE SAAS DATA PROVIDER",
    },
    {
      image:is4,
      paragraph:"Working with AIML data has been a great experience. They quickly learnt our line of business, adapted to our requirements and have consistedly performed well. They are reliable and wonderful partner.",
      line:"--LEADING BIOPHARMACEUTICAL COMPANY",
    },
    {
    image:is5,
    paragraph:"AIML Data are the experts in crowd management and have a world class assurance team. We can focus our energy more on our models and less on the quality of annotations.",
    line:"--LARGE SAAS DATA PROVIDER",
    },
    {
    image:is6,
    paragraph:"Working with AIML data has been a great experience. They quickly learnt our line of business, adapted to our requirements and have consistedly performed well. They are reliable and wonderful partner.",
    line:"--LEADING BIOPHARMACEUTICAL COMPANY",
    },
      
  // Add more slide items as needed
];


const Notepad = () =>{
  return(
    <>
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"  width="30px" height="40px" viewBox="-4 0 60 60" version="1.1">
      <title>notepad</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="People" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-4" transform="translate(-4.000000, 0.000000)" fill="#000000">
              <path d="M25,46 L35,46 C35.553,46 36,45.552 36,45 C36,44.448 35.553,44 35,44 L25,44 C24.447,44 24,44.448 24,45 C24,45.552 24.447,46 25,46 L25,46 Z M25,40 L41,40 C41.553,40 42,39.552 42,39 C42,38.448 41.553,38 41,38 L25,38 C24.447,38 24,38.448 24,39 C24,39.552 24.447,40 25,40 L25,40 Z M24,33 C24,33.552 24.447,34 25,34 L43,34 C43.553,34 44,33.552 44,33 C44,32.448 43.553,32 43,32 L25,32 C24.447,32 24,32.448 24,33 L24,33 Z M25,28 L39,28 C39.553,28 40,27.552 40,27 C40,26.448 39.553,26 39,26 L25,26 C24.447,26 24,26.448 24,27 C24,27.552 24.447,28 25,28 L25,28 Z M25,22 L41,22 C41.553,22 42,21.552 42,21 C42,20.448 41.553,20 41,20 L25,20 C24.447,20 24,20.448 24,21 C24,21.552 24.447,22 25,22 L25,22 Z M19,44 L17,44 C16.447,44 16,44.448 16,45 C16,45.552 16.447,46 17,46 L19,46 C19.553,46 20,45.552 20,45 C20,44.448 19.553,44 19,44 L19,44 Z M19,38 L17,38 C16.447,38 16,38.448 16,39 C16,39.552 16.447,40 17,40 L19,40 C19.553,40 20,39.552 20,39 C20,38.448 19.553,38 19,38 L19,38 Z M19,32 L17,32 C16.447,32 16,32.448 16,33 C16,33.552 16.447,34 17,34 L19,34 C19.553,34 20,33.552 20,33 C20,32.448 19.553,32 19,32 L19,32 Z M19,26 L17,26 C16.447,26 16,26.448 16,27 C16,27.552 16.447,28 17,28 L19,28 C19.553,28 20,27.552 20,27 C20,26.448 19.553,26 19,26 L19,26 Z M17,22 L19,22 C19.553,22 20,21.552 20,21 C20,20.448 19.553,20 19,20 L17,20 C16.447,20 16,20.448 16,21 C16,21.552 16.447,22 17,22 L17,22 Z M20,10 L40,10 L40,6 L34.899,6 C34.424,6 34.014,5.665 33.92,5.199 C33.543,3.345 31.895,2 30,2 C28.105,2 26.457,3.345 26.08,5.199 C25.986,5.665 25.576,6 25.101,6 L20,6 L20,10 Z M18,11 L18,5 C18,4.448 18.447,4 19,4 L24.343,4 C25.178,1.64 27.439,0 30,0 C32.561,0 34.822,1.64 35.657,4 L41,4 C41.553,4 42,4.448 42,5 L42,11 C42,11.552 41.553,12 41,12 L19,12 C18.447,12 18,11.552 18,11 L18,11 Z M30,4 C28.897,4 28,4.897 28,6 C28,7.103 28.897,8 30,8 C31.103,8 32,7.103 32,6 C32,4.897 31.103,4 30,4 L30,4 Z M45,56 C45.256,56 45.512,55.902 45.707,55.707 L51.707,49.707 C51.895,49.52 52,49.265 52,49 L52,9 C52,8.448 51.553,8 51,8 L45,8 C44.447,8 44,8.448 44,9 C44,9.552 44.447,10 45,10 L50,10 L50,48.586 L44.293,54.293 C43.902,54.684 43.902,55.316 44.293,55.707 C44.488,55.902 44.744,56 45,56 L45,56 Z M15,8 L9,8 C8.447,8 8,8.448 8,9 L8,52 C8,54.206 9.794,56 12,56 L41,56 C41.553,56 42,55.552 42,55 L42,49 C42,48.547 42.446,48 43,48 L47,48 C47.553,48 48,47.552 48,47 C48,46.448 47.553,46 47,46 L43,46 C41.402,46 40,47.402 40,49 L40,54 L12,54 C10.897,54 10,53.103 10,52 L10,10 L15,10 C15.553,10 16,9.552 16,9 C16,8.448 15.553,8 15,8 L15,8 Z M56,9 L56,55 C56,57.57 53.57,60 51,60 L9,60 C6.43,60 4,57.57 4,55 L4,9 C4,6.43 6.43,4 9,4 L15,4 C15.553,4 16,4.448 16,5 C16,5.552 15.553,6 15,6 L9,6 C7.542,6 6,7.542 6,9 L6,55 C6,56.458 7.542,58 9,58 L51,58 C52.458,58 54,56.458 54,55 L54,9 C54,7.542 52.458,6 51,6 L45,6 C44.447,6 44,5.552 44,5 C44,4.448 44.447,4 45,4 L51,4 C53.57,4 56,6.43 56,9 L56,9 Z" id="notepad"></path>
          </g>
      </g>
    </svg>
    </>
  )
}


const Group = () =>{
  return(
  <>
    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="30" height="40" viewBox="0 0 32 32" version="1.1">
    <title>user-group</title>
    <path d="M13 16.168c1.918-0.007 3.635-0.864 4.793-2.215l0.007-0.009c0.93 1.101 2.312 1.796 3.856 1.796 2.782 0 5.036-2.255 5.036-5.036s-2.255-5.036-5.036-5.036c-1.171 0-2.248 0.4-3.104 1.070l0.011-0.008c-1.106-1.979-3.187-3.294-5.576-3.294-3.516 0-6.366 2.85-6.366 6.366s2.85 6.366 6.366 6.366c0.005 0 0.009 0 0.014 0h-0.001zM19.152 8.172c0.643-0.643 1.532-1.040 2.513-1.040 1.964 0 3.556 1.592 3.556 3.556s-1.592 3.556-3.556 3.556c-1.244 0-2.339-0.639-2.974-1.606l-0.008-0.013c0.432-0.824 0.689-1.8 0.696-2.835v-0.002c-0.008-0.582-0.094-1.141-0.247-1.671l0.011 0.044zM13 4.909c2.695 0 4.879 2.185 4.879 4.879s-2.185 4.879-4.879 4.879-4.879-2.185-4.879-4.879c0-0 0-0 0-0.001v0c0.003-2.694 2.186-4.876 4.88-4.879h0zM30.732 24.996c-0.938-4.22-4.648-7.328-9.085-7.328-1.725 0-3.34 0.47-4.725 1.289l0.043-0.024c-1.18-0.434-2.543-0.687-3.965-0.689h-0.001c-5.713 0.024-10.488 4.013-11.717 9.356l-0.016 0.081c-0.011 0.048-0.017 0.103-0.017 0.16 0 0.414 0.336 0.75 0.75 0.75 0.357 0 0.656-0.25 0.731-0.585l0.001-0.005c1.071-4.757 5.261-8.258 10.268-8.258s9.196 3.5 10.254 8.188l0.013 0.070c0.076 0.34 0.374 0.59 0.732 0.59 0 0 0.001 0 0.001 0h-0c0.057-0 0.112-0.007 0.165-0.019l-0.005 0.001c0.34-0.076 0.59-0.375 0.59-0.733 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005c-0.79-3.454-2.981-6.285-5.929-7.916l-0.062-0.031c0.863-0.358 1.864-0.566 2.915-0.566 3.72 0 6.83 2.609 7.602 6.097l0.010 0.052c0.076 0.34 0.374 0.59 0.732 0.59 0 0 0.001 0 0.001 0h-0c0.057-0 0.112-0.007 0.165-0.019l-0.005 0.001c0.34-0.076 0.59-0.375 0.59-0.733 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005z"/>
    </svg>
  </>
    )
}

const TCard = ({svg,image,paragraph,line}) =>{
  return(
      <>
        <div className="testimonial-slide">
            {/* <img src={image} alt="VVVV"/> */}
            <div className='testimonial-svg'>
              {svg}
            </div>
            <p>{paragraph}</p>
            <h1>{line}</h1>
        </div>
      </>
  )
}



const TestimonialSlider = () => {
  const [imageRef, setImageRef] = useState(null)
  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    dots: true,
    speed: 300,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
        {
            breakpoint: 1299,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots:true,
            }
        },
        {
            breakpoint: 799,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:true,
            }
        }
    ]
  };
  

  return (
    <>
      <div class="testimonial-out">
        <Slider ref={setImageRef} {...settings}>
        {items.map((item, index) => (
            <div key={index}>
            <TCard 
            svg = {index % 2 === 0 ? <Group/> : <Notepad/>}
            image={item.image}
            paragraph={item.paragraph}
            line={item.line}
            />
            </div>
            ))}
        </Slider>
      </div>
    </>
  );
}


export default TestimonialSlider;